import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import {MenuItem, Select, Stack, Typography, useMediaQuery, useTheme} from "@mui/material";
import { useEffect, useState } from "react";
import { apiUrl } from "config/settings";
import http from 'http'
import { useDispatch } from "react-redux";
import { setShowLoading } from "store/sysSlice";
import { METER_TYPE } from "config/const";
import { findKeyByValue } from "config/functions";
import CustomIconButton from "components/CustomIconButton";
import { Add } from "@mui/icons-material";

const Header = ({createMeterRead, list, setData}) => {
  const theme = useTheme()
  const dispatch = useDispatch()
  const { bt } = useBizTypeTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [meterList, setMeterList] = useState([])
  const [selectedMeter, setSelectedMeter] = useState(null)

    useEffect(() => {
      getMeter()
    }, [])
  
    const getMeter = () => {
        dispatch(setShowLoading(true));
        http.get(`${apiUrl}/meter`).then((res) => {
          const data = res?.data?.data
          if(data?.length > 0){
            setMeterList(data);
            setSelectedMeter(data[0]?._id)
            onSelectedMeter(data[0]?._id)
          }
          dispatch(setShowLoading(false));
        });
    };

    const onSelectedMeter = (id) => {
        let newList = []
        newList = list?.filter(item => item?.meter?._id === id )
        setSelectedMeter(id)
        setData(newList)
    }

  return (
    <Stack 
      width={isMobile ? '70%' : '55%' }
      direction="row" 
      alignItems='center' 
      justifyContent="space-between"
     >
      <Select
          sx={{ width: 200, height: 40 }}
          size="small"
          MenuProps={{PaperProps: {style: {maxHeight: 150, width: 250}}}}
          value={selectedMeter}
          onChange={(e) => onSelectedMeter(e.target.value)}
        >
          {meterList?.map((meter, index) => {
            return (
              <MenuItem key={index} value={meter?._id}>
                <Typography>
                  {`${bt(findKeyByValue(METER_TYPE,meter?.type))} (${meter?.name})`}
                </Typography>
              </MenuItem>
            );
          })}
      </Select>

        <CustomIconButton 
          icon={<Add/>} 
          bgcolor='none'
          iconColor='primary.main'
          onClick={createMeterRead}
        />
    </Stack>
  );
};
export default Header;
